<template>
  <v-menu v-model="show" offset-y>
    <template v-slot:activator="{ on }">
      <v-btn text class="text-capitalize" v-on="on">
        <v-icon color="#616161" class="mr-5"> mdi-account-circle </v-icon>
        <span color="#191919">{{ username }}</span>
        <v-icon v-if="!show" color="#616161"> mdi-menu-down </v-icon>
        <v-icon v-if="show" color="#616161"> mdi-menu-up </v-icon>
      </v-btn>
    </template>
    <v-list class="py-0 seconday--font d-none d-md-block profile-menu">
      <div v-for="(items, i) in menu" :key="i">
        <v-list-item
          v-for="(item, index) in items"
          :key="index"
          :href="item.path"
          :target="item.newTab ? '_blank' : '_self'"
          v-track="item.id"
        >
          <v-list-item-icon class="mr-3 my-3">
            <v-icon v-if="item.icon != undefined" size="20">{{
              item.icon
            }}</v-icon>
            <v-img
              contain
              style="margin-top: 5px"
              width="15"
              height="15"
              v-if="item.image != undefined"
              :src="item.image"
            />
          </v-list-item-icon>
          <v-list-item-content class="py-0">
            <v-list-item-title class="caption">{{
              item.title
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider />
      </div>
      <v-list-item
        class="logoutbtn"
        @click="logout"
        v-track="'logout-nav-link'"
      >
        <v-list-item-icon class="mr-3">
          <v-icon size="20"> mdi-logout </v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class="caption"> Logout </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-menu>
</template>
<script>
import config from "@core/config/app.config.js";
import { mapGetters } from "vuex";
import axios from 'axios';
export default {
  name: "MUserDropdown",
  data() {
    return {
      show: false,
      items: [
        [
          {
            title: "Account & Billing",
            icon: "mdi-account-cog",
            path: "/account-&-billing",
            id: "account-settings-nav-link",
            relative: true,
          },
          {
            title: "Users & Permissions",
            icon: "mdi-account",
            path: "/users-&-permissions",
            id: "user-settings-nav-link",
            relative: true,
          },
          {
            title: "Profile",
            icon: "mdi-account-circle",
            id: "profile-settings-nav-link",
            newTab: true,
            path: `${config.MAROPOST_IDENTITY_BASE_URL}/#/profile`,
          },
          {
            title: "Settings",
            icon: "settings",
            relative: true,
            id: "email-settings-nav-link",
            path: "/settings",
          },
          {
            title: "Connections",
            icon: "mdi-power-plug",
            id: "connections-nav-link",
            relative: true,
            path: "/connections",
          },
          {
            title:'Process Queue',
            image:'/img/icons/waiting-list-icon.svg',
            id: "process-queue-nav-link",
            relative: true,
            path: "/process-queue"
          }
        ],
        [
          {
            title: "Maropost Galaxy",
            image: "/img/icons/maropost-insignia.svg",
            id: "maropost-galaxy-nav-link",
            newTab: true,
            path: `${config.MAROPOST_GALAXY_BASE_URL}`,
          },
          {
            title: "Roadmap",
            icon: "mdi-emoticon-outline",
            id: "roadmap-nav-link",
            newTab: true,
            path: "https://www.maropost.com/82jd8wjs7",
          },
          {
            title: "System Status",
            id: "system-status-nav-link",
            icon: "speed",
            newTab: true,
            path: "https://status.maropost.com",
          },
        ],
      ],
      marketingOnlyItems: [
        "account-settings-nav-link",
        "user-settings-nav-link",
        "connections-nav-link",
        "email-settings-nav-link",
        "system-status-nav-link"
      ],
      adminCenterItems: [
        "account-settings-nav-link",
        "user-settings-nav-link",
        "connections-nav-link",
        "email-settings-nav-link",
        "system-status-nav-link"
      ]
    };
  },
  computed: {
    ...mapGetters({
      currentAccount: "auth/account.current",
    }),
    username() {
      let username = this.$store.getters["auth/username"] || "";
      if (typeof username == "object") {
        return `${username.firstName || ""} ${username.lastName || ""}`;
      } else {
        return username;
      }
    },
    menu() {
      const accountId = this.$store.getters["auth/account"].id;
      const userPermission = this.$store.getters["auth/roles"];
      const platform = process.env.VUE_APP_PRODUCT;
      return this.items.map((item) => {
        item = item.map((subitem) => {
          if (accountId) {
            switch (platform) {
              case "Service":
                if(this.marketingOnlyItems.includes(subitem.id)) {
                  subitem = null;
                } else if(subitem.relative){
                  subitem.path = subitem.path.replace(/\/service\/\d*/g, "");
                  subitem.path = "/service/" + accountId + subitem.path;
                }
                break;
              case "Marketing":
                if(subitem.relative) {
                  subitem.path = subitem.path.replace(/\/accounts\/\d*/g, "");
                  subitem.path = "/accounts/" + accountId + subitem.path;
                }
                break;
              case "Settings":
                if(this.adminCenterItems.includes(subitem.id)) {
                  subitem = null;
                }
                break;  
            }
          }
          return subitem;
        }).filter((subitem) => subitem !== null);
        if (!userPermission.includes("account")) {
          item = item.filter(
            (subitem) => subitem.title !== "Users & Permissions"
          );
        }
        return item;
      });
    },
  },
  methods: {
    async logout() {
      await this.hubSpotLogout();
      await this.$keycloak.logout({logoutMethod:null});
      this.$store.dispatch("auth/logout");
      this.$store.commit('reloadTab',false);
      this.$store.commit('sharedEvent','reload')
    },
    async hubSpotLogout(){
      await axios.get('https://portal.maropost.com/_hcms/mem/logout')
    }
  },
};
</script>
<style>
.maro-search .v-input__slot {
  border: 1px solid #ccc;
  border-radius: 20px;
  padding-left: 5px;
}
.blue-top-ouline {
  background: linear-gradient(180deg, #03b6fc 4px, #ffffff 4px);
}
.v-input__slot:not(.v-input--is-focused):before {
  border-width: 0 !important;
}
.caption {
  font-weight: 500 !important;
}
.topheader-height {
  top: 65px !important;
  right: 0px;
  max-width: 100% !important;
  left: 0px !important;
}
.small-badge .v-badge__badge {
  min-width: 15px;
  height: 15px;
  margin-top: 4px;
  margin-right: 8px;
}
.v-badge--overlap[mdAndUp] .v-badge__badge[mdAndUp] {
  top: -9px !important;
  left: 50%;
}
.highlight {
  z-index: 10 !important;
}
.profile-menu {
  overflow-y: auto;
}
.logoutbtn:hover {
  background-color: #f6f6f6 !important;
}
.account-dropdown.v-select:link {
  color: #191919;
}
.account-dropdown {
  font-weight: 600 !important;
  letter-spacing: 0.55px;
  font-size: 13px !important;
}
.account-dropdown.v-select.v-text-field--enclosed:not(.v-text-field--single-line):not(.v-text-field--outlined)
  .v-select__selections {
  padding-top: 0px;
}
.account-dropdown .v-text-field > .v-input__control > .v-input__slot:before,
.v-text-field > .v-input__control > .v-input__slot:after {
  content: none !important;
}
.account-dropdown
  .v-input__control
  > .v-input__slot
  > .v-select__slot
  > .v-select__selections
  > .v-select__selection {
  overflow: inherit !important;
}
.account-dropdown.v-select.v-text-field input {
  width: 0px;
}
.maro-logo {
  padding-top: 10px;
}
</style>
<style scoped>
.v-list-item__title {
  -ms-flex-item-align: center;
  align-self: center;
  font-size: 0.9rem;
}
.search-account-pd-br {
  padding: 4px;
  border-radius: 5px;
  margin-bottom: -20px;
}
.account-selected {
  width: max-content;
  line-height: 2.3;
  color: rgba(0, 0, 0, 0.87);
  font-size: 13px;
  font-weight: 600;
}
.mr-arrow {
  margin-left: -12px !important;
  margin-top: 3px !important;
}
.responsive-logo {
  width: 100% !important;
  height: auto !important;
}
</style>